import { render, staticRenderFns } from "./ApplicationTab.vue?vue&type=template&id=56f14579&"
import script from "./ApplicationTab.vue?vue&type=script&lang=js&"
export * from "./ApplicationTab.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationTab.vue?vue&type=style&index=0&id=56f14579&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports